import * as React from "react";
import { API } from "../API";
import { ReferralCodeScreen } from "../components/ReferralCodeScreen";
import { Loading, loading } from "../Loading";
import { AppState } from "../system/AppState";
import { ActivityStateMixin, ActivityStateMixinState } from "./ActivityStateMixin";

interface ReferralCodeActivityProps {
  api: API;
  appState: AppState;
  onBackClick: () => void;
}

interface ReferralCodeActivityState {
  mixin: ActivityStateMixinState;
  referredBy: string | null | Loading;
}

export class ReferralCodeActivity extends React.Component<
  ReferralCodeActivityProps,
  ReferralCodeActivityState
> {
  constructor(props: ReferralCodeActivityProps) {
    super(props);

    this.activityStateMixin = new ActivityStateMixin(
      (state) =>
        this.setState((_prevState: ReferralCodeActivityState) => ({
          mixin: state,
        })),
      this.props.appState
    );

    this.state = {
      referredBy: loading(),
      mixin: this.activityStateMixin.initialState(),
    };

    this.load();
  }

  async load() {
    const temp = await this.props.api.getReferredBy();
    this.setState((_prevState: ReferralCodeActivityState) => ({
      referredBy: temp.refBy,
    }));
  }

  private activityStateMixin: ActivityStateMixin;

  componentWillUnmount() {
    this.activityStateMixin.componentWillUnmount();
  }

  async handleSubmit(code: string) {
    this.setState((_prevState: ReferralCodeActivityState) => ({
      referredBy: null,
    }));
    await this.props.api.setReferredBy(code);
    this.load();
  }

  render() {
    return (
      <ReferralCodeScreen
        onBackClick={this.props.onBackClick}
        onSubmitClick={(code) => this.handleSubmit(code)}
        referredBy={this.state.referredBy}
      />
    );
  }
}
